import { useMemo } from 'react';
import { LESSON_TYPES_INCLUDING_BLANK } from './RetroFormRadioField';
import { StatusBarType, StatusBar } from '@buildwise/libs/ui';
import { Paper, Box } from '@mui/material';
import useProjectDetailsQuery from '@buildwise/pages/project/hooks/useProjectDetailsQuery';
import { useProjectRetroContext } from '../../context';
import { useParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';

function LessonTypeSummaryBar() {
  const { projectId = '' } = useParams();
  const {
    state: { selectedLessonType, isFullScreen },
    dispatch,
  } = useProjectRetroContext();
  const { projectArticles } = useProjectDetailsQuery({
    projectId,
    shouldFetch: false,
  });
  const statusBarData = useMemo(() => {
    const data: Record<string, StatusBarType> = {};
    LESSON_TYPES_INCLUDING_BLANK.forEach((item) => {
      data[item.name] = {
        id: item.name,
        value: 0,
        backgroundColor: item.color,
        tooltipMsg: item.name,
      };
    });

    projectArticles.forEach((article) => {
      let isMatched = false;

      Object.keys(data).forEach((key) => {
        if (article.lessonTypes?.includes(data[key]?.id)) {
          data[key] = {
            ...data[key],
            value: (data[key]?.value || 0) + 1,
          };
          isMatched = true;
        }
      });

      // If no matching lesson type was found, increment the "Blank" count
      if (!isMatched) {
        data['Blank'] = {
          ...data['Blank'],
          value: (data['Blank']?.value || 0) + 1,
        };
      }
    });

    return projectArticles.length ? Object.values(data) : [];
  }, [projectArticles]);

  return (
    <>
      {statusBarData.length > 0 && (
        <Container
          sx={(theme) => ({
            boxShadow: isFullScreen ? 'none' : `0 4px 24px ${theme.palette.custom.boxShadow}`,
          })}
        >
          <StatusBar
            data={statusBarData}
            selectedValue={selectedLessonType}
            onSelect={(_, { item }) =>
              dispatch(({ state }) => ({
                payload: {
                  selectedLessonType: state.selectedLessonType?.id !== item.id ? item : undefined,
                },
              }))
            }
          />
        </Container>
      )}
    </>
  );
}

const Container = styled(Paper)(({ theme }) => ({
  padding: 8,
  borderRadius: 4,
}));

export default LessonTypeSummaryBar;
